import { Box } from '@mui/material';

/**
 * LightBoxFooter — displays filename and optional description.
 * @param {object} props
 * @param {string} props.fileName
 * @param {string} props.description
 */
export default function LightBoxFooter({ fileName, description }) {
    return (
        <Box id="lightbox-footer" className="lightbox-footer">
            <span className="lightbox-filename">{fileName}</span>
            {description && <span className="lightbox-description">{description}</span>}
        </Box>
    );
}
